<template>
    <div class="container my-3">

        <video id="beepVideoId" src="/notific.mp3" style="display: none;" ></video>

        <template v-if="msg && msg.status == 200 && sala_token">
            <az-video-call 
                :sala="sala_mrc ? sala_mrc : sala" 
                :direto="true" 
                :token="sala_token"
                :nome="( msg && msg.marcacao && msg.marcacao.nome_paciente ) ? msg.marcacao.nome_paciente : null" />
        </template>

        <template v-else-if="msg && msg.status == 200">

            <h2 class="bg-dark text-white px-3 py-2 mb-3">
                <span v-if="msg && msg.unidade">{{ msg.unidade }}</span>
            </h2>

            <card-marcacao :marcacao="msg.marcacao" />

            <!-- Action: Confirmação / Cancelamento -->
            <template v-if="msg.marcacao.ch_estado_marcacao == 'A' && !msg.marcacao.id_atendimento && action == 'cn'">

                <template v-if="msg.marcacao.status_confirmacao == 'Confirmado'">
                    <div class="alert alert-success lead">
                        Agenda Confirmada!
                    </div>
                </template>

                <template v-if="action_sel == 'canc' || action == 'canc'">
                    <div class="card">
                        <div class="card-header">
                            Motivo de Cancelamento da Marcação
                        </div>
                        <div class="card-body">
                            <textarea class="form form-control" v-model="motivo"></textarea>
                        </div>
                        <div class="card-footer">
                            <button class="btn btn-danger mr-2" :disabled="confirmando_agendamento" @click="confirmar('cancelar')">
                                <div class="spinner-border spinner-border-sm mr-2" role="status" v-if="confirmando_agendamento">
                                <span class="sr-only">Loading...</span>
                                </div>
                                Cancelar Agendamento
                            </button>
                            <button class="btn btn-outline-success" @click="action_sel = ''">Desisti de Cancelar. Confirmar Agendamento</button>
                        </div>
                    </div>
                </template>

                <template v-else-if="( msg.marcacao.status_confirmacao == 'A Confirmar' ) && msg.marcacao.dt_inicio.substr(0,10) >= $util.hoje()">
                    <div class="form-row mb-3">
                        <div class="col col-12 col-md-6 d-flex flex-column">
                            <button type="button" class="btn btn-success btn-lg" @click="confirmar()" :disabled="confirmando_agendamento">
                                <div class="spinner-border spinner-border-sm mr-3" role="status" v-if="confirmando_agendamento">
                                <span class="sr-only">Loading...</span>
                                </div>
                                Confirmar Agenda
                            </button>
                        </div>
                        <div class="col col-12 col-md-6 d-flex flex-column">
                            <button v-if="msg.url_cancelar" type="button" class="btn btn-outline-danger btn-lg" @click="cancelar_link()">Cancelar Agenda</button>
                            <button v-else type="button" class="btn btn-outline-danger btn-lg" @click="action_sel = 'canc'">Cancelar Agenda</button>
                        </div>
                    </div>
                </template>

            </template>

            <template v-if="msg.marcacao.ch_estado_marcacao == 'A' && ( action != 'cn' || msg.marcacao.status_confirmacao == 'Confirmado' )">

                <!-- Anexar Arquivos -->
                <template v-if="msg.marcacao.autorizacao && msg.marcacao.autorizacao.st_token && !msg.marcacao.autorizacao.st_codigo_autorizacao">

                    <div class="d-flex flex-column mb-3">
                        <button type="button" class="btn"
                            :class="msg.marcacao.autorizacao.arquivos.length ? 'btn-outline-success' : 'btn-primary'"
                            @click="anexar()">
                            <i class="fa fa-check mr-2" aria-hidden="true" v-if="msg.marcacao.autorizacao.arquivos.length"></i>
                            Anexar Pedido Médico (e relatório médico, se houver)
                        </button>
                    </div>

                    <az-file-upload
                        ref="upload"
                        @refresh="load()"
                        :multiple="true"
                        :arquivos="msg.marcacao.autorizacao.arquivos"
                        :parms="{
                            model_type: 'solicitacaoAutorizacao',
                            model_id: msg.marcacao.autorizacao.id_solicitacao_autorizacao,
                            token: msg.marcacao.autorizacao.st_token,
                            tipo_especial: 'paciente',
                        }"
                        :blockcelular="true" />

                </template>

                <template v-else-if="msg && msg.anexar_arquivos && 
                    ( !msg.marcacao 
                        || !msg.marcacao.id_atendimento 
                        || ( msg.marcacao && msg.marcacao.fl_tele_atendimento && msg.marcacao.dt_inicio.substr(0,10) == $util.hoje().substr(0,10) && msg.marcacao.item_status && msg.marcacao.item_status.valor != 'finalizado' )
                    )">

                    <template v-if="msg.doc_reqs && msg.doc_reqs.length">
                        <!-- Anexos -->
                        <div class="card">
                            <div class="card-header">
                                Documentos
                            </div>
                            <ul class="list-group">
                                <li class="list-group-item" v-for="(req, irx) in msg.doc_reqs" :key="irx">
                                    <div>{{ req.st_mensagem }}</div>
                                    <az-single-image-loader 
                                        :chave="'imagem_' + irx"
                                        titulo="Arquivo" 
                                        :single="true" 
                                        :arquivo="req.arquivo" 
                                        :parms="{ 
                                            model_type: 'marcacao', 
                                            model_id: msg.marcacao.id_marcacao,
                                            tipo_especial: 'paciente', // 'R' + req.id_anexo_requerido, 
                                            id_tipo_arquivo: req.id_tipo_arquivo,
                                            token: token,
                                        }" 
                                        :pode_pdf="true"
                                        service="reserva_horarios"
                                        @sync="vincular_arquivo(req, $event)">
                                    </az-single-image-loader>
                                </li>
                            </ul>
                        </div>
                    </template>

                    <template v-else>

                        <div class="d-flex flex-column mb-3">
                            <button type="button" class="btn btn-lg"
                                :class="msg.marcacao.arquivos.length ? 'btn-outline-success' : 'btn-dark'"
                                @click="anexar()">
                                <i class="fa fa-check mr-2" aria-hidden="true" v-if="msg.marcacao.arquivos.length"></i>
                                <i class="fa fa-paperclip mr-2" aria-hidden="true" v-else></i>
                                Anexar Arquivos
                            </button>
                            <small class="text-muted" v-if="msg.marcacao.procedimento.id_classe_procedimento == 1">
                                Resultado de Exames (se houver)
                            </small>
                        </div>

                        <az-file-upload
                            ref="upload"
                            @refresh="load()"
                            :multiple="true"
                            :arquivos="msg.marcacao.arquivos"
                            :blockcelular="true"
                            :parms="{
                                model_type: 'marcacao',
                                model_id: msg.marcacao.id_marcacao,
                                token: token,
                                tipo_especial: 'paciente',
                            }" />

                    </template>

                </template>

                <!-- Cadastro do Paciente -->
                <portal-cadastro-paciente v-if="msg.pre_cadastro" :action="action" :marcacao="msg.marcacao" :domain="msg.dominio" :token="token" @refresh="confirm_checkin = true" />

                <template v-else-if="msg && msg.marcacao">
                    <div class="card">
                        <div class="card-header d-flex justify-content-between">
                            <template v-if="msg.marcacao.paciente">
                                <div>
                                    <span>{{ msg.marcacao.paciente.st_nome }}</span>
                                    <small class="text-muted ml-3" v-if="msg.marcacao.paciente.cadastro && msg.marcacao.paciente.cadastro.st_email">
                                        {{ msg.marcacao.paciente.cadastro.st_email }}
                                    </small>
                                </div>
                                <div></div>
                            </template>
                            <template v-else-if="msg.marcacao.cadastro_temporario">
                                <a class="card-link" data-toggle="collapse" href="#collapseCadastro" role="button">
                                    <span>{{ msg.marcacao.cadastro_temporario.st_nome }}</span>
                                </a>
                                <div class="text-right" v-if="msg.marcacao.cadastro_temporario.st_cpf">
                                    <i class="fa fa-check text-success" aria-hidden="true"></i>
                                </div>
                                <div class="text-right" v-else>Primeira Vez</div>
                            </template>
                        </div>
                    </div>
                </template>

                <!-- Pagamento Online -->

                <template v-if="msg.marcacao && ( !msg.marcacao.id_atendimento || msg.dominio == 'labs' || msg.pre_atend_atendido )">

                    <!-- Pagamento Pendente -->
                    <pagamento-online
                        v-if="msg.marcacao.pagamento_online"
                        :value="msg.marcacao.pagamento_online"
                        :action="action"
                        :marcacao="msg.marcacao"
                        :domain="msg.dominio"
                        :token="token" />

                    <div class="card mb-3" v-for="(doc_pre, idx) in msg.doc_pre_atends" :key="'D' + idx">
                        <div class="card-header d-flex justify-content-between">
                            <a class="card-link" data-toggle="collapse" :href="'#collapse' + doc_pre.id_modelo_prontuario" role="button" aria-expanded="false" aria-controls="collapseExample">
                                {{ doc_pre.search.toUpperCase() }}
                            </a>
                            <div v-if="doc_pre.doc_pre_atend.id_documento_pre_atendimento" class="text-right">
                                <i class="fa fa-check text-success" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="collapse" :class="doc_pre.doc_pre_atend.id_documento_pre_atendimento ? '' : 'show'"
                            :id="'collapse' + doc_pre.id_modelo_prontuario">
                            <div class="card-body">
                                <formulario
                                    :compact="doc_pre.doc_pre_atend.fl_compact"
                                    v-model="doc_pre.doc_pre_atend.js_conteudo"
                                    :saved="saved"
                                    mode="fixed"
                                    :config="true" />
                            </div>
                            <div class="card-footer">
                                <az-submit @click="atualizar_doc_pre(doc_pre)">Atualizar</az-submit>
                            </div>
                        </div>
                    </div>

                </template>

                <div v-if="msg.marcacao && msg.marcacao.item_status && msg.marcacao.item_status.valor != 'finalizado'">

                    <template v-if="countdown && ( countdown.dias || countdown.horas || countdown.minutos > 5 )">

                        <template v-if="msg.marcacao.plano.search.substr(0,5).toUpperCase() == 'CHAPP' && msg.marcacao.fl_tele_atendimento">

                            <template v-if="countdown.dias == 0 && countdown.horas < 2">

                                <template v-if="msg.marcacao.dt_checkin">
                                    <p class="alert alert-primary text-center">Check-In Realizado às {{ msg.marcacao.dt_checkin.substr(11,5) }}</p>
                                </template>

                                <template v-else-if="!msg.marcacao.id_atendimento && !msg.marcacao.dt_checkin">

                                    <div class="d-flex flex-column mb-3">
                                        <button type="button" class="btn btn-primary" @click="fazer_checkin()"
                                            :disabled="fazendo_check_in">
                                            <div class="spinner-border spinner-border-sm mr-2" role="status" v-if="fazendo_check_in">
                                                <span class="sr-only">Loading...</span>
                                            </div>
                                            <i class="fa fa-check mr-2" aria-hidden="true" v-else></i>
                                            Clique aqui para fazer o Check-In
                                        </button>
                                    </div>

                                    <p class="alert alert-info text-center">Ao fazer o check-in, você informa que está disponível para iniciar o atendimento.</p>

                                </template>

                            </template>

                            <template v-else-if="countdown.dias == 0 && countdown.horas > 2 && !msg.marcacao.id_atendimento && !msg.marcacao.dt_checkin">
                                <p class="alert alert-info text-center">A partir de duas horas para o atendimento, será disponibilizada a opção de realizar check-in para você poder informar que está disponível para o atendimento.</p>
                            </template>

                        </template>

                        <h3 class="text-center mb-3" v-if="msg.marcacao.fl_tele_atendimento && msg.marcacao.dt_inicio.substr(0,10) == $util.hoje().substr(0,10)">
                            Aguardando abertura da sala
                        </h3>

                        <h3 class="text-center mb-3" v-else-if="msg.marcacao.dt_inicio.substr(0,10) > $util.hoje().substr(0,10)">
                            Contagem Regressiva
                        </h3>

                        <div class="d-flex justify-content-center">
                            <table class="border m-1 p-2 text-center">
                                <tr>
                                    <td class="bg-dark display-4 px-2">
                                        <pre class="text-white mb-0">{{ this.dias() }}</pre>
                                    </td>
                                    <td class="bg-dark display-4 px-2">
                                        <pre class="text-white mb-0">{{ countdown.horas }}</pre>
                                    </td>
                                    <td class="bg-dark display-4 px-2">
                                        <pre class="text-white mb-0">{{ countdown.minutos }}</pre>
                                    </td>
                                    <td class="bg-dark display-4 px-2">
                                        <pre class="text-white mb-0">{{ countdown.segundos }}</pre>
                                    </td>
                                </tr>
                                <tr class="small text-muted">
                                    <td>
                                        <small>{{ countdown.dias > 1 ? 'dias' : 'dia' }}</small>
                                    </td>
                                    <td><small>hr</small></td>
                                    <td><small>min</small></td>
                                    <td><small>seg</small></td>
                                </tr>
                            </table>
                        </div>

                    </template>

                    <template v-else>
                        <h3 class="text-center mb-3" v-if="msg.marcacao.fl_tele_atendimento && msg.marcacao.dt_inicio.substr(0,10) == $util.hoje().substr(0,10)">
                            Aguardando abertura da sala
                        </h3>
                    </template>

                </div>

                <div v-if="lista_agrupada" class="mb-3">
                    <div v-for="(items, quebra, iqx) in lista_agrupada" :key="'L' + iqx">
                        <div class="card mb-1">
                            <div class="card-body d-flex justify-content-between">
                                <div>
                                    <template v-if="items.length == 1">
                                        {{ items[0].procedimento.search }}
                                    </template>
                                    <div v-else>
                                        <div v-for="(item, iix) in items" :key="'I' + iix" class="mr-1">
                                            <a href="#" @click.prevent="imprimir(item)">
                                                <span class="badge mr-1" :class="'badge-' + ( item.laudo.status_laudo ? item.laudo.status_laudo.st_color : 'secondary' )"
                                                    data-toggle="tooltip" data-placement="top" :title="item.laudo.status_laudo.search">
                                                    {{ item.procedimento.search }}
                                                </span>
                                            </a>

                                            <span class="ml-3 small text-muted" v-if="msg && msg.exibir_dt_entrega && item.dt_entrega">
                                                Entrega: {{ $util.getFormatDate(item.dt_entrega) }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="mt-3 small text-muted" v-if="msg && msg.exibir_dt_entrega && prazo_final(items)">
                                        Data de Entrega: {{ prazo_final(items) }}
                                    </div>
                                </div>

                                <div>
                                    <template v-if="items.length == 1">
                                        <template v-if="items[0].laudo.arquivos && items[0].laudo.arquivos.length">
                                            <a :href="arq.arquivo.temporary_url" class="btn ml-1" :class="arq.st_tipo_especial == 'anexo' ? 'btn-outline-secondary' : 'btn-outline-primary'" v-for="(arq, iax) in items[0].laudo.arquivos" :key="'A' + iax"
                                                target="_blank" title="Imprimir">
                                                <i class="fa fa-paperclip" aria-hidden="true" v-if="arq.st_tipo_especial == 'anexo'"></i>
                                                <i class="fa fa-print" aria-hidden="true" v-else></i>
                                            </a>
                                        </template>
                                        
                                        <template v-if="items && items[0] && items[0].st_pacs == 'OK'">
                                            <button type="button" class="btn btn-outline-dark ml-1" @click="open_url_estudo(items[0])">
                                                Imagens
                                            </button>
                                        </template>

                                        <template v-if="!(items[0].laudo.arquivos && items[0].laudo.arquivos.filter(arq => arq.st_tipo_especial != 'anexo').length) && items[0].laudo.status_laudo">
                                            <button type="button" class="btn btn-outline-primary ml-1" :disabled="!items[0].laudo.status_laudo.fl_pronto" @click="imprimir(items[0])" title="Imprimir">
                                                Laudo
                                            </button>
                                        </template>
                                    </template>
                                    <template v-else-if="items.length > 1">
                                        <button type="button" class="btn btn-outline-primary ml-1" title="Imprimir" @click="imprimir_lab(items[0])">
                                            Laudo
                                        </button>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>

                    <pre v-if="false">{{ lista_agrupada }}</pre>

                </div>

                <div v-else-if="msg.marcacao && msg.marcacao.item_status && msg.marcacao.item_status.valor == 'finalizado'" class="alert alert-primary">
                    Atendimento Finalizado.
                </div>

                <div v-else-if="msg.marcacao && msg.marcacao.ch_estado_marcacao == 'A' && msg.marcacao.id_atendimento && 
                    ( !msg.marcacao.fl_tele_atendimento || msg.marcacao.dt_inicio.substr(0,10) != $util.hoje().substr(0,10) )" class="alert alert-primary">
                    Atendimento Realizado.
                </div>

                <div v-if="msg.qs">
                    <div class="card mb-3">
                        <div class="card-header d-flex justify-content-between">
                            <a class="card-link" data-toggle="collapse" :href="'#collapse' + msg.qs.id_modelo_prontuario" role="button" aria-expanded="false" aria-controls="collapseExample">
                                {{ msg.qs.search.toUpperCase() }}
                            </a>
                            <div v-if="msg.qs.doc_pre_atend.id_documento_pre_atendimento" class="text-right">
                                <i class="fa fa-check text-success" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="collapse" :class="msg.qs.doc_pre_atend.id_documento_pre_atendimento ? '' : 'show'"
                            :id="'collapse' + msg.qs.id_modelo_prontuario">
                            <div class="card-body">
                                <formulario
                                    :compact="msg.qs.doc_pre_atend.fl_compact"
                                    v-model="msg.qs.doc_pre_atend.js_conteudo"
                                    :saved="saved"
                                    :mode="( !msg.qs.doc_pre_atend.created_at || msg.qs.doc_pre_atend.created_at.substr(0,10) == $util.hoje() ) ? 'fixed' : 'view'"
                                    :config="true" />
                            </div>
                            <div class="card-footer" v-if="!msg.qs.doc_pre_atend.created_at || msg.qs.doc_pre_atend.created_at.substr(0,10) == $util.hoje()">
                                <az-submit @click="atualizar_doc_pre(msg.qs)">Atualizar</az-submit>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Informação de Check-In Realizado -->
                <div class="alert alert-success" v-if="check_realizado == 9">
                    <i class="fa-solid fa-check mr-3"></i>
                    <strong>Processo Concluído.</strong>
                </div>

                <template v-if="msg.marcacao && !msg.marcacao.fl_tele_atendimento && msg.telegram_bot && msg.marcacao.dt_inicio.substr(0,10) <= $util.hoje()">

                    <div class="d-flex flex-column mb-3">
                        <template v-if="!msg.marcacao.telegram_chat_id">
                            <a :href="'https://t.me/' + msg.telegram_bot" class="btn btn-primary" target="_blank">
                                <i class="fab fa-telegram my-2 fa-3x"></i>
                                <h3>
                                    Clique Aqui para Conectar ao Sistema de Chamada @{{ msg.telegram_bot }}
                                </h3>
                                <div>Código da Reserva: {{ this.msg.marcacao.codigo_reserva }}</div>
                            </a>
                            <p class="text-center">
                                Nosso sistema de chamada também funciona com o Telegram. Você deve ter instalado o App do Telegram para poder receber nossas notificações.
                            </p>
                            <div class="text-center">
                                <a href="https://apps.apple.com/br/app/telegram-messenger/id686449807"
                                    target="_blank" v-if="is_ios">
                                    <img src="https://api.klingo.app/apple-store.png" style="max-height: 60px;">
                                </a>

                                <a href="https://play.google.com/store/apps/details?id=org.telegram.messenger&hl=en"
                                    target="_blank" v-if="is_android">
                                    <img src="https://api.klingo.app/google-play-store.png" style="max-height: 60px;">
                                </a>

                                <a href="https://desktop.telegram.org/" class="btn btn-primary"
                                    target="_blank" v-if="!is_android && !is_ios">
                                    Baixar Telegram para Desktop
                                </a>
                            </div>
                        </template>
                        <div class="alert alert-info" v-else>
                            <div>
                                Você já está conectado ao nosso telegram @{{ msg.telegram_bot }}.
                            </div>
                            <div>
                                Para reconectar em outro telefone,
                                <a :href="'https://t.me/' + msg.telegram_bot" class="card-link" target="_blank">
                                    clique aqui, e informe seu código de reserva
                                </a>
                                {{ this.msg.marcacao.codigo_reserva }}.
                            </div>
                        </div>
                    </div>
                </template>

            </template>

            <template v-if="msg && msg.lista_inst">
                <div class="alert alert-warning" v-for="(inst, iix) in msg.lista_inst" :key="'T' + iix">
                    <span v-if="inst.html" v-html="inst.content"></span>
                    <span v-else style="white-space: pre-wrap;">{{ inst.content }}</span>
                </div>
            </template>

            <hr>

            <br><br><br>

        </template>

        <template v-else-if="msg && msg.status != 200">
            <h4>Token inválido.</h4>
        </template>

        <template v-else>
            <az-loading msg="Aguarde..." />
        </template>

        <pre v-if="false">{{ msg }}</pre>

        <Toast :baseZIndex="99999" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import * as moment from "moment";
import AzVideoCall from '../shared/zoom/AzVideoCall.vue';
import { setInterval } from "timers";
import { subscribe } from "../../service/Notify";
import AzLoading from '../util/AzLoading.vue';
import CardMarcacao from './CardMarcacao.vue';
import PagamentoOnline from '../../components/shared/pagamento/PagamentoOnline.vue';
import Formulario from '../../components/modulos/consultorio/Formulario.vue';
import PortalCadastroPaciente from './PortalCadastroPaciente.vue';
import AzSubmit from '../util/AzSubmit.vue';
import AzFileUpload from '../util/AzFileUpload.vue';
import AzSingleImageLoader from '../util/AzSingleImageLoader.vue';

export default {
    data () {
        return {
            msg: null,
            sala_token: null,
            sala_mrc: "",
            countdown: "",
            tmaInterval: null,
            retorno: "",
            testecd: null,
            confirmando_pagamento: false,
            confirmando_agendamento: false,
            confirmado: false,
            saved: true,
            motivo: "",
            action_sel: "",
            fazendo_check_in: false,
            confirm_checkin: false, 
        }
    },

    components: {
        AzVideoCall,
        AzLoading,
        CardMarcacao,
        PagamentoOnline,
        Formulario,
        PortalCadastroPaciente,
        AzSubmit,
        AzFileUpload,
        AzSingleImageLoader, 
    },

    props: ['sala', 'token', 'id_marcacao', 'action'],

    computed: {
        check_realizado: function () { 
            if ( !this.$route.query.c ) 
                return 1; 

            if ( !this.msg || !this.msg.anexar_arquivos || ( this.msg.marcacao && this.msg.marcacao.id_atendimento ) ) 
                return 2;

            if ( !this.msg.doc_reqs || !this.msg.doc_reqs.length ) 
                return 3;

            let teste = this.msg.doc_reqs.find(doc => !doc.arquivo)

            if ( teste )
                return teste;

            if ( !this.confirm_checkin )
                return 5;

            return 9; 
        },

        is_ios: function () {
            return navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
        },

        is_android: function () {
            let ua = navigator.userAgent.toLowerCase();
            return ua.indexOf("android") > -1;
        },

        lista: function () {
            if ( !this.msg || !this.msg.marcacao || !this.msg.marcacao.atendimento || !this.msg.marcacao.atendimento.atendimento_procedimentos )
                return [];

            return this.msg.marcacao.atendimento.atendimento_procedimentos;
        },

        lista_agrupada: function () {
            if ( !this.lista.length )
                return null;

            return _.groupBy(this.lista, (item) => {
                return item.procedimento.id_especialidade == 2
                    ? 'L' + item.id_atendimento
                    : item.id_atendimento_procedimento;
            });
        },
    },

    methods: {
        beep() {
            const el = document.getElementById("beepVideoId");
            el.play();
        },

        vincular_arquivo (req, arquivo) { 
            req.arquivo = arquivo;

            this.$forceUpdate();
        },

        open_url_estudo(item) {
            let url = 'https://resultado.klingo.app/pacs/'
                + this.msg.dominio + '/'
                + this.msg.marcacao.id_marcacao + '/'
                + item.id_atendimento_procedimento + '/'
                + this.token + '/'
                + 'imagens';

            window.open(url, '_blank').focus();
            
        },
        
        prazo_final(atps) { 
            let prazo = _.get(
                _.maxBy(atps, 'dt_entrega'), 
                'dt_entrega'
            );

            return prazo ? this.$util.getFormatDate(prazo) : null;
        },

        imprimir_lab(laudo) {
            let url = 'https://resultado.klingo.app/imprimir/'
                + this.msg.dominio + '/'
                + this.msg.marcacao.id_marcacao + '/'
                + laudo.id_atendimento + '/'
                + this.token + '/'
                + 'laudo_lab/'
                + '?papel=A4-NT'
                + '&mb=1';

            window.open(url, '_blank').focus();
        },

        imprimir(laudo) {
            let url = 'https://resultado.klingo.app/imprimir/'
                + this.msg.dominio + '/'
                + this.msg.marcacao.id_marcacao + '/'
                + laudo.laudo.id_laudo + '/'
                + this.token + '/'
                + 'laudo/'
                + '?papel=A4-NT'
                + '&mb=1';

            window.open(url, '_blank').focus();
        },

        fazer_checkin() {
            this.fazendo_check_in = true;

            this.axios.post('video/marcacao/checkin', {
                id_marcacao: this.msg.marcacao.id_marcacao,
                domanin: this.msg.dominio,
                token: this.token,
            })
            .then(res => {
                console.log('Res', res);
                if ( res.data ) {
                    this.msg.marcacao.dt_checkin = res.data.dt_checkin;
                    this.msg.marcacao.id_atendimento = res.data.id_atendimento;
                }
            })
            .finally(() => {
                this.fazendo_check_in = false;
            });
        },

        cancelar_link() {

            if(!this.msg || !this.msg.url_cancelar) {
                this.$toast.add({
                        severity: "warn",
                        summary: "Atenção",
                        detail: "Url para cancelamento inválida.",
                        life: 3000
                    });

                return;
            }

            window.open(this.msg.url_cancelar, '_blank').focus();

        },

        confirmar(acao = 'confirmar') {
            if ( acao == 'cancelar' ) {
                if ( !this.motivo ) {
                    this.$toast.add({
                        severity: "warn",
                        summary: "Atenção",
                        detail: "Informe o motivo do cancelamento.",
                        life: 3000
                    });
                    return;
                }

                if ( !confirm('Confirma cancelar o agendamento? Essa ação é irreversível.') )
                    return;
            }

            this.confirmando_agendamento = true;

            this.axios.post('video/marcacao/conf', {
                id_marcacao: this.msg.marcacao.id_marcacao,
                domanin: this.msg.dominio,
                token: this.token,
                action: acao,
                motivo: this.motivo,
                origem: (this.$route && this.$route.query && this.$route.query.o) ? this.$route.query.o : null,
                disparo: (this.$route && this.$route.query && this.$route.query.disparo) ? this.$route.query.disparo : null,
            })
            .then(res => {
                if ( res.data ) {
                    if ( acao == 'confirmar' ) {
                        this.msg.marcacao.status_confirmacao = res.data.status_confirmacao;
                    } else {
                        this.msg.marcacao.ch_estado_marcacao = res.data.ch_estado_marcacao;
                    }
                }
            })
            .finally(() => {
                this.confirmando_agendamento = false;
            });
        },

        reload() {
            console.log('Reload...');
        },

        dias() {
            return ( this.countdown.dias < 10 ? '0' : '' ) + this.countdown.dias;
        },

        atualizar_doc_pre(doc_pre) {

            const modal = 'collapse' + doc_pre.id_modelo_prontuario;

            $('[data-toggle="tooltip"]').tooltip("dispose");

            this.$store.commit('loading', true);

            this.axios.post('portal/form/store', {
                    doc_pre: doc_pre.doc_pre_atend,
                    d: this.msg.dominio,
                    m: this.msg.marcacao.id_marcacao,
                    t: this.token,
                })
                .then(res => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Atenção",
                        detail: "Atualização realizada com sucesso.",
                        life: 3000
                    });

                    doc_pre.doc_pre_atend.id_documento_pre_atendimento = res.data.id_documento_pre_atendimento;

                    $('#' + modal).collapse('hide');

                    this.$emit('refresh');
                })
                .finally(() => {
                    this.$store.commit('loading', false);
                });

        },

        confirmar_pagamento () {
            this.confirmando_pagamento = true;

            this.axios.post('video/confirmar_pagamento', {
                id_marcacao: this.msg.marcacao.id_marcacao,
                domanin: this.msg.dominio,
                token: this.token,
            })
            .then(res => {
                this.msg.marcacao.pagamento_online.js_resposta = res.data;
                this.msg.marcacao.pagamento_online.ch_status = res.data.ch_status;
                this.msg.marcacao.pagamento_online.status_pagamento = res.data.status_pagamento;

                this.confirmado = true;
            })
            .finally(() => {
                this.confirmando_pagamento = false;
            });
        },

        anexar() {
            this.$refs.upload.abrir();
        },

        load() {

            return this.axios.get('/video/share_check?room=' + this.sala 
                    + '&key=' + this.token 
                    + '&m=' + this.id_marcacao 
                    + '&a=' + ( this.action ? this.action : '' ) 
                    + '&p=' + ( ( this.$route && this.$route.query && this.$route.query.p ) ? this.$route.query.p : '' )
                    + '&tp=' + ( ( this.$route && this.$route.query && this.$route.query.tp ) ? this.$route.query.tp : '' ),
                )
                .then(res => {
                    this.msg = res.data;
                    this.sala_mrc = this.msg.sala;
                    this.sala_token = this.msg.token;

                    return res;
                })
                .finally(() => {
                    this.$store.commit('loading', false);
                });

        }
    },

    mounted () {

        if ( !this.id_marcacao ) {
            this.sala_token = this.token;
        }

        if ( process.env.VUE_APP_GTAG ) {
            this.$gtag.set({'dimension2': 'paciente'});
        }

        this.load()
            .then(() => {

                if ( this.id_marcacao && this.msg.marcacao ) {

                    // Criação do Contador Regressivo

                    if ( !this.sala_token ) {

                        if ( this.tmaInterval )
                            clearInterval(this.tmaInterval);

                        this.tmaInterval = setInterval(() => {
                            let now = moment();
                            let end = moment(this.msg.marcacao.dt_inicio.substr(0, 16), 'YYYY-MM-DD HH:mm');
                            let diff = end.diff(now);
                            let dias = end.diff(now, 'days');

                           if ( end > now ) {

                                this.countdown = {
                                    dias: dias,
                                    horas: moment.utc(diff).format("HH"),
                                    minutos: moment.utc(diff).format("mm"),
                                    segundos: moment.utc(diff).format("ss"),
                                }

                           } else {

                               this.countdown = null;

                           }

                        }, 1000);

                    }

                    if ( this.msg.dominio ) {

                        let sala_nofify = this.msg.sala 
                            ? "video-chamada-" + this.msg.sala 
                            : "video-chamada-" + this.msg.marcacao.id_marcacao + '-' + this.msg.marcacao.codigo_reserva;

                        subscribe(
                            this.msg.dominio,
                            sala_nofify,
                            retorno => {
                                console.log('retorno', retorno);

                                this.retorno = retorno;

                                if ( this.retorno.data.acao == 'finalizar' ) {

                                    this.msg.marcacao.item_status.valor = "finalizado";
                                    this.sala_token = "";

                                } else {

                                    if ( this.retorno.data.id_marcacao == this.msg.marcacao.id_marcacao 
                                        || this.msg.sala == this.retorno.data.room ) {

                                        this.sala_token = this.retorno.data.token;

                                        this.beep();
                                        
                                    }

                                }

                            }
                        );

                        if ( process.env.VUE_APP_GTAG ) {

                            let action = 'acesso-pre-cadastro';
                            let label = this.msg.marcacao.id_marcacao;

                            this.$gtag.event(action, {
                                'event_category': this.msg.dominio,
                                'event_label': label,
                                'value': 1
                            });

                        }

                    }

                }

            });

    }
}
</script>
